import { useParams } from "react-router";
import { SelectNumberForm } from "@/components/forms/select-number-form";
import { Steps } from "@/components/steps";

export default function Plans() {
  const { service } = useParams();

  return (
    <div className="space-y-12">
      <Steps className="mx-auto flex max-w-2xl" currentStep={2} />

      <SelectNumberForm
        className="space-y-12"
        serviceType={service as ServiceType}
      />
    </div>
  );
}
